'use client';

import { useTranslations } from 'next-intl';
import { getSideMenuList } from '../../../utils';
import { MyEquipmentLoader } from '../my-equipment/my-equipment-loader';
import { ProductCardGridLoader } from '../../product-card/product-card-loader';
import { ServiceInsightSkeletonLoader } from '../service-Insight/service-insight-card/service-insight-loader';

export const CustomerAccountLoading = ({ menu }) => {
  const sideMenuList = getSideMenuList();
  const t = useTranslations();
  switch (menu) {
    case sideMenuList.my_eqp.name:
      return <MyEquipmentLoader />;
    case sideMenuList.recently_viewed.name:
      return <ProductCardGridLoader title={t('RECENTLY_VIEWED')} />;
    case sideMenuList.service_insights.name:
      return <ServiceInsightSkeletonLoader />;
    default:
      return '';
  }
};
